import React from 'react'
import { Pot } from './Pot'

export const Bush = ({ position, rotation, scale = 1 }) => {
	return (
		<group castShadow position={position} scale={scale} rotation={rotation}>
			<Pot scale={10} />
			<mesh position={[0, 25, 0]} rotation={[Math.PI / 2, 0, 0]} castShadow>
				<torusKnotGeometry args={[5, 5, 60, 50, 1, 10]} />
				<meshStandardMaterial color={'green'} />
			</mesh>
		</group>
	)
}
